<template>
    <div class="personal-ins" v-if="!$route.query.wfhistory">
     <!-- <div class="flex-end p-2" v-if="mode==='edit'"><button class="btn pointer">Start All</button></div> -->
    <div class="personal-ins-acc" v-if="Object.keys(materialToInstancesMap).length">
      <div
      v-for="(data, materialId, index) in materialToInstancesMap"
      :key="index"
      class="personal-ins-acc-item"
      >
      <div class="personal-ins-acc-header" @click="toggle(materialId)">
        <div class="v-center space-between">
          <div>
            <span class="arrow" :class="{ open: activeMaterial === materialId }" v-if="data.length">
              >
            </span>
            {{ getMaterialName(materialId) }}
          </div>
          <div class="flex v-center">
            <span class="xs mr-2">{{ showCompletedCount(materialId) }}</span>
                <div class="personal-ins-progress-bar"><progressbar :percentage="getPercentage(materialId)"></progressbar></div>
                <!-- start permission restricted only for Admins-->
                <div v-if="notAllowedRolesToStart"></div>
                <div v-else-if="(mode === 'edit' || mode === 'draft') && data.length===0">
                  <button v-if="mode === 'draft'" v-tooltip="'Please submit the job order form to start the production'" class="btn pointer m" disabled="true">
                    Start
                    </button>
                  <button v-if="mode === 'edit'" class="btn pointer m" @click.stop="startInstances(materialId)">
                    <span v-if="isStarting === materialId">
            <spinner ></spinner>
                       </span>
                       <span v-else>
                          Start
                    </span>
                  </button>
                </div>
                <div v-else class="status" :class="getStatusClass(materialStatusMap[materialId] ? materialStatusMap[materialId] : 2)">
                  {{materialStatusMap[materialId] ? config.MATERIAL_WORKFLOW_STATUS[materialStatusMap[materialId]] : config.MATERIAL_WORKFLOW_STATUS[2]}}
                </div>
              </div>

            </div>
        </div>
        <transition
          name="accordion"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
          <div
            class="personal-ins-acc-content"
            v-show="activeMaterial === materialId"
          >
            <div class="copy-dtx-table">
              <table>
                <thead>
                  <tr>
                    <th class="th-scaled-down">Sl.No</th>
                    <th class="th-scaled-down elispis-text">Current Step</th>
                    <th class="th-scaled-down">Status</th>
                    <th class="th-scaled-down qr-header">QR</th>
                    <th class="th-scaled-down qr-header">History</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(material, index) of data"
                    :key="index"
                    class="pointer"
                    :class="{ 'highlighted-row': isRowHighlighted(material) }"
                    @click="showWfInstanceDetails(material.id, materialId, index)"
                  >
                    <td class="m">{{`${getMaterialName(materialId)} #${index + 1}`}}</td>
                    <td class="current-step-column" style="max-width: 220px;">
                     <span :title="material?.current_instance_step?.workflow_step?.name ?? material?.transition_history[0]?.current_workflow_step?.name" v-overflow-tooltip class="weight-200 m elipsis-text">{{ material?.current_instance_step?.workflow_step?.name ?? material?.transition_history[0]?.current_workflow_step?.name }}</span>
                    <br/>
                     <span :title="material?.current_instance_step?.workflow_step?.core_user_group?.name ?? material?.transition_history[0]?.current_workflow_step?.core_user_group?.name" class="mt-4 text-grey m">{{ material?.current_instance_step?.workflow_step?.core_user_group?.name ?? material?.transition_history[0]?.current_workflow_step?.core_user_group?.name }}</span>
                      <br/>
                      <!-- {{ material?.current_instance_step.projected_end_date }} -->
                    </td>
                    <td><div class="status" :class="getStatusClassFromString(material?.state_value?.name)">{{ material.state_value?.name }}</div></td>
                    <td class="qr-cell">
                      <button
                        type="button"
                        class="qr-code-btn"
                        :class="{ 'qr-disabled': !material?.bar_code_blob_key }"
                        v-tooltip="material?.bar_code_blob_key ? 'Show QR Code' : 'QR not available'"
                        @click.stop.prevent="handleQrClick(material, materialId, index)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="rgb(74, 144, 226)"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          style="display: block;"
                        >
                          <rect x="3" y="3" width="7" height="7" />
                          <rect x="14" y="3" width="7" height="7" />
                          <rect x="3" y="14" width="7" height="7" />
                          <path d="M14 14h7v7h-7z" />
                          <path d="M17 17v-3" />
                          <path d="M17 17h3" />
                        </svg>
                      </button>
                    </td>
                    <td class="qr-cell">
                     <img
                      src="~@/assets/images/icons/history-circle.svg"
                       alt="history"
                       v-tooltip="'View History'"
                       class="pointer"
                       @click.stop="showHistory(material.id)"
                      />
                        </td>
                      <td>
                        <div class="flex-end">
                     <img
                      src="~@/assets/images/icons/arrow-circle.svg"
                       alt=""
                      />
                        </div>
                        </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <modal
      :open="qrCodeModal"
      title="Material Instance QR Code"
      :closeOnOutsideClick="true"
      @close="closeQRCodeModal"
    >
      <div class="qr-modal-content">
        <div class="qr-code-container">
          <div class="qr-code-display">
            <div v-if="loadingQRCode" class="qr-loading">
              <loading-circle />
              <p>Loading QR Code...</p>
            </div>
            <img
              v-else-if="selectedInstanceQR"
              :src="selectedInstanceQR"
              :alt="`QR Code for ${selectedInstanceForQR?.materialName}`"
            />
            <p v-else class="qr-missing">QR not available</p>
            <div class="qr-actions">
            <button
                class="btn btn-black mr-2 pointer"
                 @click="downloadInstanceQRCode"
                 :disabled="loadingQRCode || !selectedInstanceForQR?.bar_code_blob_key"
  >
  <div class="flex v-center">
    <img
      src="~@/assets/images/icons/download-icon-white.svg"
      alt=""
      width="20px"
      class="mr-2"
      />
      Download
    </div>
     </button>
       <button class="btn pointer" @click="closeQRCodeModal">
        Close
      </button>
        </div>
          </div>
            <div class="activeStep">
              <!-- Top Row -->
              <div class="step-header space-between v-center">
                <div class="v-center">
                  <div v-overflow-tooltip class="step-name elipsis-text">
                    {{ workflowData?.stepName }}
                  </div>
                  <div class="mb-1 ml-2">
                    <div
                      :class="{
                        'v-center workflowStatus status-tag': true,
                        'not-started':
                          workflowData?.state_value?.name === 'NOT_STARTED',
                        ongoing: workflowData?.state_value?.name === 'ONGOING',
                        completed:
                          workflowData?.state_value?.name === 'COMPLETED',
                        cancelled:
                          formData?.status === config.FORM_STATE_MAP.CANCELLED,
                      }"
                    >
                      <span
                        v-if="
                          formData?.status === config.FORM_STATE_MAP.CANCELLED
                        "
                      >
                        CANCELLED</span
                      >
                      <span v-else>{{
                        workflowData?.state_value?.name | statusfomat
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="v-center"
              >
                <div class="v-center">
                  <div class="dept">Material :</div>
                  <div class="date-value ml-1">
                    {{
                      `${selectedInstanceForQR?.materialName} #${selectedInstanceForQR?.sequence}`
                    }}
                  </div>
                </div>
                <div
                  v-if="workflowData?.workflow_stage?.qc_parent_step_id"
                  class="v-center"
                >
                  <label class="dept">Checklist Status:</label>
                  <div :class="['status-display']">
                    <div class="status-icon">
                      <div
                        :class="[
                          'status-circle',
                          getStatusClasss({ value: workflowData?.qcFormStatus }),
                        ]"
                      >
                        <span class="status-symbol">{{
                          getStatusIcon({ value: workflowData?.qcFormStatus })
                        }}</span>
                      </div>
                    </div>
                    <span class="status-text">{{
                      workflowData?.qcFormStatus | getQCStatusName
                    }}</span>
                  </div>
                </div>
              </div>
              <!-- Dept Row -->
              <div
                class="flex v-venter"
                v-if="workflowData?.state_value?.name !== 'COMPLETED'"
              >
                <div class="dept">Department :</div>
                <div class="date-value ml-1">
                  {{ workflowData?.core_user_group?.name ?? "--" }}
                </div>
                <br />
              </div>
              <div
                class="v-center"
                v-if="
                  workflowData?.state_value?.name !== 'COMPLETED' &&
                  formattedIndependentUsers.length
                "
              >
                <div class="dept">Assignees :</div>
                <div class="avatar-container flex ml-3">
                  <avatar
                    v-for="user in formattedIndependentUsers"
                    :key="user.id"
                    :user="user.assigned_user"
                    :title="getUserTooltip(user.assigned_user)"
                    style="margin-right: -9.5px"
                  />
                  <avatar
                    style="margin-right: -13.5px"
                    v-if="formattedIndependentUsersExceededCount"
                    :exceeded-count="formattedIndependentUsersExceededCount"
                    :title="
                      formattedIndependentUsersExceededCount + ' ' + 'more'
                    "
                  />
                </div>
                <br />
              </div>
              <div class="border"></div>
              <!-- Date/Duration Row -->
              <div class="date-row space-between">
                <div class="date-block">
                  <div class="xs label">Start Date</div>
                  <div class="flex v-center">
                    <div class="date-detail mr-1">Expected :</div>
                    <div class="date-value">
                      {{ workflowData?.planned_start_date | genericFormatDate }}
                    </div>
                  </div>
                  <div class="flex v-center">
                    <div class="date-detail">Actual :</div>
                    <div class="date-value">
                      {{ workflowData?.actual_start_date | genericFormatDate }}
                    </div>
                  </div>
                </div>
                <div
                  class="duration-block"
                  v-if="workflowData?.state_value?.name !== 'COMPLETED'"
                >
                  <div class="label">Duration</div>
                  <div class="duration-value">{{ formattedDuration }}</div>
                </div>

                <div class="date-block">
                  <div class="xs label">End Date</div>
                  <div class="v-center">
                    <div class="date-detail">Expected :</div>
                    <div class="date-value">
                      {{ workflowData?.planned_end_date | genericFormatDate }}
                    </div>
                  </div>
                  <div class="flex v-center">
                    <div class="date-detail">Actual :</div>
                    <div class="date-value">
                      {{
                        workflowData?.workflow_stage
                          ?.current_step_transition_history[0]?.end_date
                          | genericFormatDate
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- Upload Section -->
              <!-- <div class="upload-row">
          <div class="upload-box">
          <div class="weight-500" >File Upload</div>
        <img src="~@/assets/images/icons/upload-icon.svg" class="upload-icon" />
        <button class="btn">Browse</button>
      </div>
  <div class="uploaded-files-box">
    <div class="uploaded-header">Uploaded files</div>
    <div v-if="files.length" class="uploaded-list">
      <div
        v-for="(file, index) in files"
        :key="index"
        class="uploaded-file"
      >
        <div class="file-name">{{ file.name }}</div>
        <div class="file-status">
          <span v-if="file.status === 'uploading'" class="loader"></span>
          <span v-else>{{ file.size }}</span>
        </div>
      </div>
    </div>
      <div v-else class="no-files">
    No Files Attatched
  </div>
  </div>
        </div> -->
              <div
                class="resource-item"
                v-if="workflowData?.workflow_stage?.workflow_step_resources_associations?.length > 0 && selectedResources.length > 0"
              >
                <div class="dept">Resources :</div>
                <div class="duration-value v-center">
                  <span v-for="(resource, index) in selectedResources" :key="index">
                    {{ resource.label }}<span v-if="index < selectedResources.length - 1">, </span>
                  </span>
                </div>
              </div>
            </div>
        </div>
      </div>
    </modal>
  </div>
  <div v-else-if="$route.query.wfhistory">
      <version-history :formTypeId="config.FORM_TEMPLATE_TYPE.JOF" :rootFormId="null" :selectedTab="config.FORM_TAB_STATUS.HISTORY"  :instanceId="$route.query.wfhistory" :formId="null"/>
  </div>
</template>

<script>
import { startMaterialWorkflow, getLastStepHistoryData, workflowDataBasedOnInstanceId } from '@/api'
import { genericFormatDate } from '@/utils/date'
import { timeStampToDate } from '@/filters/dateFilter'
import { alert, success } from '@/plugins/notification'
import progressbar from '@/components/common/progressbar.vue'
import Spinner from '@/components/common/spinner.vue'
import config from '@/config'
import { mapGetters } from 'vuex'
import Modal from '@/components/common/modal.vue'
import { generateS3DownloadingUrlSingle } from '@/api/apis/documents'
import loadingCircle from '@/components/common/loadingCircle.vue'
import VersionHistory from './versionHistory.vue'
export default {
  name: 'processPlanList',
  components: { Spinner, progressbar, Modal, loadingCircle, VersionHistory },
  data () {
    return {
      materialToInstancesMap: {},
      isStarting: null,
      materialStatusMap: {},
      config,
      qrCodeModal: false,
      selectedInstanceForQR: null,
      selectedInstanceQR: '',
      loadingQRCode: false,
      wftInstaceId: null,
      workflowData: {},
      formData: {},
      formattedIndependentUsers: [],
      formattedIndependentUsersExceededCount: 0,
      selectedResources: []
    }
  },
  props: {
    activeMaterial: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'view'
    },
    materialProcessPlanLinks: {
      type: Array,
      default: () => []
    },
    materialIdToDetailMap: {
      type: Object,
      default: () => ({})
    },
    createdByUserId: {
      type: String,
      default: ''
    }
  },
  filters: {
    timeStampToDate,
    genericFormatDate,
    statusfomat (value) {
      if (!value) return ''
      return value.replace(/_/g, ' ')
    }
  },
  watch: {
    materialProcessPlanLinks () {
      this.buildMaterialMap()
    },

    highlightedMaterialName (newMaterialName) {
      if (newMaterialName && this.materialToInstancesMap[newMaterialName]?.length > 0) {
        this.$emit('selectActiveMaterial', newMaterialName)
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    highlightedMInstId () {
      return this.$route.query.mInst || null
    },

    highlightedMaterialName () {
      if (!this.highlightedMInstId) return null

      for (const [materialName, instances] of Object.entries(this.materialToInstancesMap)) {
        const hasHighlightedInstance = instances.some(instance => instance.id === this.highlightedMInstId)
        if (hasHighlightedInstance) {
          return materialName
        }
      }
      return null
    },
    notAllowedRolesToStart () {
      if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
        return false
      } else if (this.createdByUserId === this.user.userId && (this.user.tenantLevelRole === 'COLLABORATOR' || this.user.projectLevelRole === 'COLLABORATOR')) {
        return false
      }
      return true
    },
    formattedDuration () {
      const duration = this.workflowData?.duration
      const durationType = this.workflowData?.duration_type

      if (!duration || !durationType) return '--'

      return this.formatDuration(duration, durationType)
    }
  },
  methods: {
    getStatusClasss (status) {
      const statusClasses = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: 'in-progress',
        [config.FORM_STATE_MAP.APPROVED]: 'approved',
        [config.FORM_STATE_MAP.REJECTED]: 'rejected',
        [config.FORM_STATE_MAP.HOLD]: 'hold'
      }
      return statusClasses[status?.value] || 'in-progress'
    },
    getStatusIcon (status) {
      const statusIcons = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: '✓',
        [config.FORM_STATE_MAP.APPROVED]: '✓',
        [config.FORM_STATE_MAP.REJECTED]: '✗',
        [config.FORM_STATE_MAP.HOLD]: '⏸'
      }
      return statusIcons[status?.value] || '✓'
    },
    formatDuration (duration, durationType) {
      // If Days, just show as is
      if (durationType === 1) {
        return `${duration} ${duration === 1 ? 'Day' : 'Days'}`
      }

      // If Hours
      if (durationType === 2) {
        const days = Math.floor(duration / 24)
        const hours = duration % 24

        if (days > 0 && hours > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'} ${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        } else if (days > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'}`
        } else {
          return `${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        }
      }

      // If Minutes
      if (durationType === 3) {
        const days = Math.floor(duration / (60 * 24))
        const hours = Math.floor((duration % (60 * 24)) / 60)
        const minutes = duration % 60

        const parts = []
        if (days > 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`)
        if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`)
        if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'Min' : 'Mins'}`)

        return parts.length > 0 ? parts.join(' ') : '0 Mins'
      }

      return `${duration} ${this.config.DURATION_TYPE[durationType]}`
    },
    getWorkFlowStepData () {
      if (!this.wftInstaceId) {
        this.sideBarLoading = false
        return
      }
      workflowDataBasedOnInstanceId(this.wftInstaceId, this.isExternalCollaborator).then((res) => {
        const wf = res.workflow_instances_by_pk
        this.workflowData = {
          stepId: wf?.workflow_stage?.id,
          qcFormId: wf?.workflow_stage?.current_step_transition_history?.[0]?.form_id,
          qcFormStatus: wf?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status,
          qc_parent_step_id: wf?.workflow_stage?.qc_parent_step_id,
          qc_form_template_id: wf?.workflow_stage?.qc_form_template_id,
          instance_step_assignees: wf?.workflow_instance_steps?.[0]?.instance_step_assignees || [],
          core_user_group: wf?.workflow_stage?.core_user_group,
          planned_start_date: wf?.workflow_instance_steps?.[0]?.planned_start_date,
          actual_start_date: wf?.workflow_stage?.current_step_transition_history?.[0]?.start_date,
          planned_end_date: wf?.workflow_instance_steps?.[0]?.planned_end_date,
          state_value: wf?.state_value,
          duration: wf?.workflow_stage?.duration,
          duration_type: wf?.workflow_stage?.duration_type,
          workflow_version_id: wf?.workflow_version?.id,
          workflowTypeName: wf?.workflow_version?.workflow_template?.type_value?.name,
          stepName: wf?.workflow_stage?.name,
          workflow_stage: wf?.workflow_stage || {}
        }
        if (this.workflowData.stepIterationCount) {
          if (this.workflowData?.instance_step_assignees.length < 3) {
            this.formattedIndependentUsers = this.workflowData?.instance_step_assignees
          } else {
            this.formattedIndependentUsers = this.workflowData.instance_step_assignees.slice(0, 3)
            this.formattedIndependentUsersExceededCount = this.workflowData.instance_step_assignees.length - 3
          }
          if (this.workflowData?.instance_step_resources?.length > 0) {
            const resources = this.workflowData?.instance_step_resources
            this.selectedResources = resources.map(resource => ({
              value: resource?.factory_resource_instance?.id,
              label: resource?.factory_resource_instance?.name,
              resource_id: resource?.resource_id
            }))
          }
        }
        if (this.workflowData.state_value?.name === 'COMPLETED') {
          try {
            getLastStepHistoryData(this.wftInstaceId).then((res) => {
              this.workflowData.stepId = res.workflow_instances_by_pk.transition_history[0].step_id
              this.workflowData.qcFormId = res.workflow_instances_by_pk.transition_history[0].form_id
              this.workflowData.qcFormStatus = res.workflow_instances_by_pk.transition_history[0]?.qc_form?.status
              this.workflowData.qc_parent_step_id = res.workflow_instances_by_pk.transition_history[0]?.current_workflow_step?.qc_parent_step_id
              this.workflowData.qc_form_template_id = res.workflow_instances_by_pk.transition_history[0]?.current_workflow_step?.qc_form_template_id
              this.workflowData = { ...this.workflowData }
            })
              .catch(err => {
                console.log(err)
              })
          } catch (err) {
            console.log(err)
          }
        }
      }).catch(err => {
        console.error(err)
        alert('Failed to fetch workflow data')
      }).finally(() => {
        this.sideBarLoading = false
      })
    },
    getMaterialName (materialId) {
      if (this.materialIdToDetailMap[materialId]?.length) {
        return this.materialIdToDetailMap[materialId][0]?.core_material_master?.material_name
      } else {
        return this.materialIdToDetailMap[materialId]?.name
      }
    },
    autoOpenDetailsIfNeeded () {
      // This is now a fallback - the direct opening happens in viewForm.vue
      if (!this.mInstDetailsId) return

      // Find the material instance with the matching ID
      for (const [materialName, instances] of Object.entries(this.materialToInstancesMap)) {
        const instanceIndex = instances.findIndex(instance => instance.id === this.mInstDetailsId)

        if (instanceIndex !== -1) {
          // Expand the material accordion first
          this.$emit('selectActiveMaterial', materialName)

          // Wait for accordion animation (600ms as per CSS) plus buffer, then open details
          setTimeout(() => {
            const material = instances[instanceIndex]
            this.showWfInstanceDetails(material.id, materialName, instanceIndex)
          }, 700)

          break
        }
      }
    },

    isRowHighlighted (material) {
      const workflowInstanceId = material?.id
      return this.highlightedMInstId && workflowInstanceId === this.highlightedMInstId
    },
    getPercentage (materialId) {
      const length = this.materialToInstancesMap[materialId]?.length
      if (length) {
        let completedCount = 0
        for (const item of this.materialToInstancesMap[materialId]) {
          if (item.state_value.name === 'COMPLETED') {
            completedCount++
          }
        }
        return (completedCount / length) * 100
      } else return 0
    },
    showCompletedCount (materialId) {
      const length = this.materialToInstancesMap[materialId]?.length
      if (length) {
        let completedCount = 0
        for (const item of this.materialToInstancesMap[materialId]) {
          if (item.state_value.name === 'COMPLETED') {
            completedCount++
          }
        }
        return `${completedCount} / ${length} completed`
      } else {
        return `0 / ${this.materialIdToDetailMap[materialId]?.quantity} completed`
      }
    },
    formatDate (date) {
      if (!date) return 'N/A'
      const d = new Date(date)
      return d.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getStatusClassFromString (status) {
      switch (status) {
      case 'ONGOING':
        return 'status-active'
      case 'NOT_STARTED':
        return 'status-not-started'
      case 'COMPLETED':
        return 'status-completed'
      default:
        return ''
      }
    },
    getStatusClass (status) {
      switch (status) {
      case 1:
        return 'status-active'
      case 2:
        return 'status-not-started'
      case 4:
        return 'status-completed'
      default:
        return ''
      }
    },
    showWfInstanceDetails (instanceId, materialId, index) {
      // Update URL with mInstDetails
      const newQuery = { ...this.$route.query, mInstDetails: instanceId }
      // Remove mInst parameter when opening details (mInst is for highlighting, mInstDetails is for opening)
      delete newQuery.mInst
      this.$router.push({
        path: this.$route.path,
        query: newQuery
      })

      this.$emit('showWfInstanceDetails', { instanceId, name: this.getMaterialName(materialId), index })
    },
    handleQrClick (material, materialId, index) {
      if (!material?.bar_code_blob_key) return
      this.showInstanceQRCode(material, materialId, index)
    },
    async showInstanceQRCode (instance, materialId, index) {
      this.wftInstaceId = instance.id
      if (!instance?.bar_code_blob_key) {
        alert('QR Code not available for this workflow instance')
        return
      }
      this.getWorkFlowStepData()
      this.qrCodeModal = true
      this.loadingQRCode = true
      this.selectedInstanceForQR = {
        ...instance,
        materialName: this.getMaterialName(materialId),
        sequence: index + 1
      }
      this.selectedInstanceQR = ''
      try {
        const response = await generateS3DownloadingUrlSingle({
          fileName: encodeURIComponent(`${this.selectedInstanceForQR.materialName || 'material'}-${this.selectedInstanceForQR.sequence}-qr.png`),
          S3Key: instance.bar_code_blob_key
        })
        if (response?.url) {
          this.selectedInstanceQR = response.url
        } else {
          throw new Error('Failed to fetch S3 URL')
        }
      } catch (error) {
        console.error('Error loading QR code:', error)
        alert('Failed to load QR code from S3')
        this.closeQRCodeModal()
      } finally {
        this.loadingQRCode = false
      }
    },
    closeQRCodeModal () {
      this.qrCodeModal = false
      this.selectedInstanceForQR = null
      this.selectedInstanceQR = ''
      this.loadingQRCode = false
    },
    async downloadInstanceQRCode () {
      if (!this.selectedInstanceForQR?.bar_code_blob_key || this.loadingQRCode) return
      try {
        this.loadingQRCode = true
        const response = await generateS3DownloadingUrlSingle({
          fileName: `material-${this.selectedInstanceForQR.materialName || 'instance'}-${this.selectedInstanceForQR.sequence}-qr.png`,
          S3Key: this.selectedInstanceForQR.bar_code_blob_key
        })
        if (response?.url) {
          const res = await fetch(response.url)
          const blob = await res.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `material-${this.selectedInstanceForQR.materialName || 'instance'}-${this.selectedInstanceForQR.sequence}-qr.png`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          throw new Error('Failed to fetch S3 URL')
        }
      } catch (error) {
        console.error('Error downloading QR code:', error)
        alert('Failed to download QR code')
      } finally {
        this.loadingQRCode = false
      }
    },
    buildMaterialMap () {
      const map = {}
      for (const key in this.materialIdToDetailMap) {
        map[key] = []
      }
      if (this.materialProcessPlanLinks.length) {
        for (const item of this.materialProcessPlanLinks[0]?.core_form?.forms_material_lists) {
          this.materialStatusMap[item.core_material.id] = item.status
        }
      }
      this.materialProcessPlanLinks.forEach(item => {
        const materialId = item.workflow_instance.core_material_master.id
        const obj = JSON.parse(JSON.stringify(item))
        if (!map[materialId]) {
          map[materialId] = []
        }
        const instanceWithQRCode = {
          ...obj.workflow_instance,
          bar_code_blob_key: obj.bar_code_blob_key
        }
        map[materialId].push(instanceWithQRCode)
      })
      this.materialToInstancesMap = map
    },
    startInstances (materialId) {
      if (this.isStarting) return
      this.isStarting = materialId
      const formId = this.$route.params.formId
      const workflowData = [{
        material_id: this.materialIdToDetailMap[materialId]?.id,
        step_id: this.materialIdToDetailMap[materialId]?.stepId,
        resources: []
      }]
      startMaterialWorkflow(workflowData, formId).then(() => {
        this.$emit('refreshData')
        success('Material workflow started successfully')
      }).catch(() => {
        alert('Failed to start material workflow')
      }).finally(() => {
        this.isStarting = null
      })
    },
    toggle (materialId) {
      if (this.materialToInstancesMap[materialId].length === 0) return
      const activeMaterial = this.activeMaterial === materialId ? null : materialId
      this.$emit('selectActiveMaterial', activeMaterial)
    },
    beforeEnter (el) {
      el.style.height = '0'
    },
    enter (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave (el) {
      el.style.height = '0'
    },
    showHistory (instanceId) {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, wfhistory: instanceId }
      })
    },
    goBack () {
      this.$router.replace({
        path: this.$route.path,
        query: {}
      })
    }
  },
  created () {
    this.buildMaterialMap()
  }
}
</script>

<style lang="scss" scoped>

.th-scaled-down {
  font-size: small;
  font-weight: 400;
  color: #666666;
}

.updated-info {
  font-size: var(--text-xs2);
  color: #666;
  display: flex;
  gap: 2px;
  align-items: center;
}

.status {
    font-size: var(--text-m);
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: fit-content;
    padding: 3px 4px;
    border-radius: 3px;
    background-color: orange;
    &-not-started {
        background-color: #fff3cd; /* Light yellow */
        color: #856404; /* Dark yellow */
    }
    &-completed {
        background-color: #cce5ff; /* Light blue */
        color: #004085; /* Dark blue */
    }
    &-active {
        background-color: #d4edda; /* Light green */
        color: #155724; /* Dark green */
    }
  }

.arrow {
  display: inline-block;
  font-size: var(--text-s);
  margin-right: 8px;
  transition: transform 0.3s ease;
}

.qr-header {
  width: 60px;
  text-align: center;
}

.qr-cell {
  text-align: center;
}

.qr-code-btn {
  border: none;
  background: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #000;
  cursor: pointer;
}

.qr-code-btn:hover {
  color: #333;
}

.qr-code-btn.qr-disabled {
  color: #b8b8b8;
  cursor: not-allowed;
  pointer-events: none;
}

.qr-modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 47vh;
  align-items: center;
}

@media (min-width: 560px) {
  .qr-code-container {
    flex-direction: row;
    align-items: flex-start;
  }
}

.qr-code-display {
  min-height: 220px;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d7d7d7;
  border-radius: 8px;
  padding: 16px;
}

.qr-loading {
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 8px;
  min-height: 220px;
  min-width: 220px;
  align-items: center;
  justify-content: center;
  color: #666;
}

.qr-code-display img {
  max-width: 220px;
  max-height: 220px;
}

.qr-info {
  text-align: center;
}

.qr-info-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.qr-info-subtitle {
  font-size: var(--text-m);
  color: #666;
}

.qr-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.arrow.open {
  transform: rotate(90deg); // pointing down when open
}

.personal-ins {
  &-progress-bar {
    width: 7rem;
    margin-right: 1rem;
  }
  .current-step-column {
     width: 220px;  // Changed from max-width to width
  max-width: 220px;  // Keep this for extra safety
  line-height: 1.4rem;
  overflow: hidden;  // NEW: Required for ellipsis
  text-overflow: ellipsis;  // NEW: Shows ... when text overflows
  white-space: nowrap;
  }
  border-radius: 6px;
  height: calc(100vh - 270px);
  overflow-y: auto;
  &-label {
    color: black;
    margin-block: 1rem;
  }
  &-table {
    width: 100%;
    table {
      width: 100%;
      position: relative;
      border-collapse: collapse;

      th {
        position: sticky;
        width: auto;
        top: 0px;
        font-weight: 500;
        background-color: var(--brand-color);
      }
      tr {
        z-index: 0;
        cursor: pointer;
      }
      th,
      td {
        text-align: left;
        font-size: var(--text-s);
        padding: 8px 4px;
      }
      tr:nth-child(odd) {
        background-color: rgba(var(--brand-rgb), 0.05);
        border: 1px solid var(--brand-color);
      }
    }

      .highlighted-row {
        background-color: #FFF3CD !important;
        border: 2px solid #FFC107 !important;
        box-shadow: 0 0 10px rgba(255, 193, 7, 0.3) !important;

        td {
          background-color: transparent !important;
        }

        &:hover {
          background-color: #FFE69C !important;
          border-color: #FFB300 !important;
        }
      }

      // More specific selector to override any conflicting styles
      tr.highlighted-row {
        background-color: #FFF3CD !important;
        border: 2px solid #FFC107 !important;
        box-shadow: 0 0 10px rgba(255, 193, 7, 0.3) !important;

        td {
          background-color: transparent !important;
        }

        &:hover {
          background-color: #FFE69C !important;
          border-color: #FFB300 !important;
        }
      }
    &-overdue {
      color: red;
    }
  }
  &-acc {
    border: 1px solid #ddd;
    border-radius: 5px;
    &-item {
      border-top: 1px solid #ddd;
    }
    &-header {
      border-left: 4px solid var(--brand-color);
      padding: 15px;
      background: #fff;
      cursor: pointer;
      &:hover {
        background: #e7e7e7;
      }
    }
    &-content {
      overflow: auto;
      transition: height 0.6s ease;
    }
  }
}

/* Highlighted row styles for URL parameter highlighting */
tr.highlighted-row {
  background-color: #FFF3CD !important;
  border: 2px solid #FFC107 !important;
  box-shadow: 0 0 10px rgba(255, 193, 7, 0.3) !important;

  td {
    background-color: transparent !important;
    color: #000 !important;
  }

  &:hover {
    background-color: #FFE69C !important;
    border-color: #FFB300 !important;
  }
}

/* Transition classes */
.accordion-enter-active,
.accordion-leave-active {
  transition: height 0.6s ease;
}

.accordion-enter,
.accordion-leave-to {
  height: 0;
}

.activeStep {
  min-height: 290px;
  max-height: 290px;
  padding: 5px 5px;
  background: white;
  border-radius: 6px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 20px;

  .step-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .step-left {
      display: flex;
      flex-direction: column;
      gap: 6px;

      .step-name {
        font-size: var(--text-4xl);
        font-weight: 500;
      }
    }

    .step-center {
      text-align: center;

      .step-label {
        font-size: var(--text-base);
        // color: gray;
      }

      .step-duration {
        font-size: var(--text-2xl);
        font-weight: 500;
      }
    }

    .step-right {
      align-self: flex-start;
    }
  }

  .step-department {
    font-size: var(--text-2xl);
    font-weight: 500;
    color: #333;
  }

  .step-info-row {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    .start-block,
    .end-block {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;

      .block-title {
        font-size: var(--text-l);
        font-weight: 600;
        margin-bottom: 6px;
      }

      .block-item {
        display: flex;
        gap: 8px;

        .label {
          font-weight: 500;
          // color: #666;
        }

        .value {
          font-weight: 600;
        }
      }
    }
  }
}

.activeStep {
  padding: 16px 20px 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.step-name {
  max-width: 330px;
  font-size: var(--text-4xl);
  font-weight: 600;
}

.dept {
  font-size: var(--text-s);
  // margin-top: -20px;
  color: #696969;
  font-weight: 400;
}
.border {
  // box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
  border-top: 1px solid #dcdcdc;
}
.date-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.label {
  font-size: var(--text-s);
  color: #696969;
  font-weight: 500;
  margin-bottom: 4px;
}

.date-block {
  display: flex;
  flex-direction: column;
  font-size: var(--text-base);
}

.date-detail {
  margin-right: 2px;
  font-size: var(--text-s);
  color: #696969;
  margin-bottom: 2px;
}
.date-value {
  font-size: var(--text-s);
}

.duration-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.duration-value {
  // color: #696969;
  font-size: var(--text-s);
  font-weight: 500;
  // margin-top: -5px;
}

.status-tag {
  padding: 2px 4px;
  border-radius: 6px;
  font-weight: 600;
  display: inline-block;
  min-width: 100px;
  text-align: center;
}

.not-started {
  background-color: rgba(255, 0, 0, 0.1);
  color: purple;
}

.completed {
  background-color: rgba(0, 128, 0, 0.1);
  color: green;
}

.ongoing {
  background-color: rgba(255, 165, 0, 0.1);
  color: orange;
}
</style>
